// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3IMnS","content":"LayoutSettings_content__OCA63"};